// ============================================================================
// SEED / DEMO GROUPS
// ----------------------------------------------------------------------------
// Placeholder groups shown in the Groups directory so it doesn't look empty
// while real groups are created. Same pattern as src/data/seedMembers.js:
// each has `isSeed: true` and a `seed-group-*` id, kept in ONE file so they're
// easy to find and DELETE as real groups appear.
//
// Admin can hide ALL demo content (these + seed members) site-wide via the
// "Demo content" toggle on the Admin Dashboard (settings/seedContent.hidden).
// To remove individual demos permanently, delete entries from this file.
// ============================================================================

export const SEED_GROUPS = [
  {
    id: 'seed-group-1', isSeed: true,
    name: 'Investment Banking Professionals',
    description: 'Discuss live deals, market trends, and career moves with fellow IB professionals.',
    members: 156, posts: 324, category: 'Industry', image: '',
  },
  {
    id: 'seed-group-2', isSeed: true,
    name: 'Private Equity & Buyouts',
    description: 'Sourcing, diligence, value creation, and exits — a hub for PE and buyout pros.',
    members: 112, posts: 210, category: 'Industry', image: '',
  },
  {
    id: 'seed-group-3', isSeed: true,
    name: 'M&A Legal & Tax',
    description: 'Deal structuring, due diligence, and regulatory considerations for M&A counsel and tax advisors.',
    members: 89, posts: 167, category: 'Specialty', image: '',
  },
  {
    id: 'seed-group-4', isSeed: true,
    name: 'Corporate Development',
    description: 'In-house dealmakers sharing strategy, integration, and pipeline best practices.',
    members: 74, posts: 131, category: 'Industry', image: '',
  },
  {
    id: 'seed-group-5', isSeed: true,
    name: 'Wealth Management & Liquidity',
    description: 'Advisors helping founders and executives plan around liquidity events.',
    members: 68, posts: 96, category: 'Specialty', image: '',
  },
  {
    id: 'seed-group-6', isSeed: true,
    name: 'Women in Finance',
    description: 'A supportive community for women across investment banking, PE, and advisory.',
    members: 134, posts: 245, category: 'Community', image: '',
  },
];
